import { flow } from 'lodash';
import { routeSelector } from 'store/state/selectors/router';
import { createSelector } from 'reselect';
import { poiSelector } from 'store/state/selectors/searchListView';
import { searchLastInGeometryIdSelector, searchDocEntriesSelector, searchListTotalSelector, searchListItemsPerPageLimit, searchListTotalNearbySelector } from 'store/state/domainData/selectors';
import { CardPoi } from './residential/ListView';

export const pageSelector = flow(routeSelector, ({ params }) => params.page);

const EMPTY: CardPoi = [];

export const multiSearchAwarePoiSelector = createSelector([
  poiSelector,
  searchLastInGeometryIdSelector,
  searchDocEntriesSelector,
], (poi, lastInGeometryId, addresses) => {
  const isSingleAddress = addresses && addresses.length === 1;
  const lastPoiIndex = poi.findIndex((entry) => entry.id === lastInGeometryId);
  // if multi-search - show only the main cards and stop once lastIndex is reached
  const poiToRender: CardPoi = poi && poi.length > 0
    ? poi.slice(0, isSingleAddress ? Infinity : (lastPoiIndex + 1 || Infinity))
    : EMPTY;

  return poiToRender;
});

export const searchListTotalPagesSelector = createSelector([
  searchListTotalSelector,
  searchListTotalNearbySelector,
  searchListItemsPerPageLimit,
  searchDocEntriesSelector,
], (allTotal, totalNearby, limit, addresses) => {
  const isSingleAddress = addresses && addresses.length === 1;
  const total = isSingleAddress ? allTotal : allTotal - totalNearby;
  return Number.isInteger(total) && limit ? Math.ceil(total / limit) : null;
});
